import React from 'react';
import { authRoles, PERMISSION } from 'app/auth';
import i18next from 'i18next';
import { MENU_ENUM } from 'app/main/role/constants';
import en from '../i18n/en';

i18next.addResourceBundle('en', 'printProfile', en);

const UpdatePrintProfileConfig = {
  settings: {
    layout: {
      config: {},
    },
    nav: {
      title: 'Update Print Options',
    },
  },
  auth: authRoles.user,
  key: MENU_ENUM.PRINT_PROFILE,
  permission: PERMISSION.UPDATE,
  routes: [
    {
      path: '/print-profile/:id',
      component: React.lazy(() => import('./UpdatePrintProfile')),
    },
  ],
};

export default UpdatePrintProfileConfig;
